import Controller from "@ember/controller";

export default class FollowController extends Controller {}
